import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiWindows11,
} from "react-icons/si";

import {
  DiEclipse,
  DiIntellij,
  DiMysql,
  DiMongodb
} from "react-icons/di";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="Windows 11/10/7">
        <SiWindows11 />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="VS Code">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Postman">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Eclipse">
        <DiEclipse />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Intellij IDE">
        <DiIntellij />
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons" title="MySql WorkBench">
        <p className="toolname">MySql Workbench</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Mongo DB Compass">
        <p className="toolname">Mongo DB Compass</p>
      </Col> */}
      
      
    </Row>
  );
}

export default Toolstack;
